<div *ngIf="content" [appCopyToClipboard]="content" matTooltip="Copy to clipboard" matTooltipPosition="left">
	<button class="copy-to-clipboard" mat-button color="primary">
		<mat-icon>content_copy</mat-icon>
	</button>
	<div class="content" [class.overflow-ellipsis]="overflowEllipsis" >
		<ng-content></ng-content>
	</div>
</div>
